import type { Environment } from "@porsche-customer/slfinrtl-environment"

// ignore `.cn` domain that dealer app might be served from since customer finder is on `.com` only
export const finderCustomerHostname: Record<Environment, string> = {
	dev: "https://finder-k.porsche.com",
	local: "https://finder-k.porsche.com",
	preview: "https://finder-preview.porsche.com",
	prod: "https://finder.porsche.com",
}
